import * as React from 'react'

import { cn, styled } from '~/styled'

import { useCarousel } from './Carousel'

const Dot = styled('button', {
  base: [
    'bg-grey-600',
    'cursor-pointer',
    'duration-100',
    'ease-in',
    'focus:bg-primary-900',
    'hover:bg-primary-900',
    'mx-1',
    'p-1',
    'rounded-full',
    'size-3',
    'transition-all',
    'disabled:bg-primary-800',
    'disabled:cursor-default'
  ]
})

export const CarouselPagination = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  const { scrollSnaps, selectedIndex, scrollTo } = useCarousel()

  const dots = Array.from({ length: scrollSnaps.length }, (_, i) => i)

  return (
    <div className={cn('flex', 'justify-center', className)} {...rest}>
      {dots.map((index) => (
        <Dot
          key={index}
          type="button"
          onClick={() => scrollTo(index)}
          disabled={index === selectedIndex}
          aria-label="slide dot"
        />
      ))}
    </div>
  )
}
